<template>
  <div>

    <!--------------------------hamburger menu----------------------------->
    <v-app-bar
            v-if="hamburger_menu"
            :app="app_val"
            id="site-menu"
            elevation="0"
    >
      <a href="/">
        <img src="../assets/images/logo/advizerai.png" height="40px">
      </a>

      <span class="pa-3"></span>


      <v-spacer></v-spacer>

      <v-menu
              bottom
              origin="center center"
              transition="scale-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn
                  icon
                  :dark="dark"
                  v-on="on"
          >
            <v-icon>menu</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
                  v-for="(item, i) in items"
                  :key="i"
          >
            <v-list-item-title>
              <v-btn text :to="item.url" :dark="dark">{{ item.name }}</v-btn>
              </v-list-item-title>
          </v-list-item>



          <v-list-item>
            <v-list-item-title>
              <v-btn text href="https://app.advizer.ai">
                <span style="text-align: center">Login</span>
              </v-btn>
            </v-list-item-title>
          </v-list-item>

        </v-list>
      </v-menu>
    </v-app-bar>




    <!--------------------------full size menu----------------------------->
    <v-app-bar
            v-else
            :app="app_val"
            id="site-menu"
            elevation="0"
    >
      <a href="/">
        <!--<img src="../assets/images/logo/espy-logo-dark-bg.svg" width="250px">-->
        <!--<img src="../assets/images/logo/espy-analytics-logo-dark-bg.svg" width="180px">-->
        <img src="../assets/images/logo/advizerai.png" height="50px">




      </a>

      <span class="pa-3"></span>

      <v-spacer></v-spacer>


      <v-btn
              v-for="(item, i) in items"
              :key="i"
              text
              :to="item.url"
              :dark="dark"
              :light="light"
      >
        {{ item.name }}
      </v-btn>


      <!--<v-btn text to="/about">Services</v-btn>-->
      <!--<v-btn text to="/about">About Us</v-btn>-->
      <!--<v-btn text to="/about">Team</v-btn>-->
      <!--<v-btn text to="/about">Contact Us</v-btn>-->

      <v-btn text href="https://app.advizer.ai"
             :dark="dark"
             :light="light">
        <span style="text-align: center">Login</span>
      </v-btn>


    </v-app-bar>


  </div>

</template>


<style>

  #site-menu{
  background: none;
  }



</style>
<script>
export default {
  name: 'NavBar',
   props:{
     app: Boolean,
      dark: {type: Boolean, },
      light: {type: Boolean, }
   },

  data: () => ({
     show_menu: false,
   items: [
      {name: 'Product', url: '/product'},
      {name: 'Pricing', url: '/pricing'},
      // {name: 'Work', url: '/about'},
      // {name: 'About', url: '/about'},
      {name: 'Contact', url: '/contact'},
      // {name: 'Covid Model', url: '/covid-model'},
   ]
  }),
   methods:{
      toggle_menu(){
         if (['xs', 'sm'].includes(this.$vuetify.breakpoint.name)){
            this.show_menu=false;
            return;
         }

         this.show_menu = !this.show_menu;


      }
   },

   computed:{

     hamburger_menu(){
        return (['xs', 'sm'].includes(this.$vuetify.breakpoint.name));
     },

      app_val()
      {
         if (this.app !== undefined)
            return this.app;
         else return false;
      }
   },

   created(){
     console.log(this.$vuetify.breakpoint)
   }
};
</script>
